class AssetPredictionsRequestBody {
  ids = undefined;
  paths = []; // [] => all forecast measures for the asset
  starting = undefined; // Required by backend.
  ending = undefined; // Required by backend.
  pointsAmount = undefined; // Optional: keep only last N computed values per target.
}

export default AssetPredictionsRequestBody;
